const surfaceEntryValidator = value => parseInt(value, 10) > 8
const surfaceValidator = number => Math.round(parseInt(number.toString().replace(/^(0+)/g, ''), 10))

const nameEntryValidator = name => /^[A-ZÂÄÀÉÈÙÊËÎÏÔÖÇÑ '-]*$/i.test(name)
const nameValidator = name => name.length > 1

const phoneEntryValidator = phone => /^\+?[0-9]{0,10}$/.test(phone)
const phoneValidator = phone => phone.length === 10 && phone.split('')[0] === '0'

export default {
  entry: {
    surface: surfaceEntryValidator,
    name: nameEntryValidator,
    phone: phoneEntryValidator,
  },
  format: {
    surface: surfaceValidator,
    name: nameValidator,
    phone: phoneValidator,
  },
}
